import { Brightness5, ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Grid, IconButton, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ForecastContainer from 'features/forecasts/ForecastContainer';
import { useEnabledLocations } from 'features/locations/api/getLocations';

export const WeatherWidgetItemTypes = {
  ANALYZER: 'analyzer',
};

const WeatherWidget = () => {
  const { data: locations } = useEnabledLocations({
    config: { refetchInterval: 60000 },
  });
  const [locationIdx, setLocationIdx] = useState(0);

  useEffect(() => {
    const idx = localStorage.getItem('widget_location');
    if (!isNaN(Number(idx))) setLocationIdx(Number(idx));
  }, []);

  useEffect(() => {
    if (!locations) return;
    if (locationIdx > locations.length - 1) setLocationIdx(0);
  }, [locations, locationIdx]);

  const goForward = () => {
    if (!locations) return;
    const idx = (locationIdx + 1) % locations.length;
    setLocationIdx(idx);
    localStorage.setItem('widget_location', '' + idx);
  };

  const goBack = () => {
    if (!locations) return;
    const idx = (locationIdx - 1 + locations.length) % locations.length;
    setLocationIdx(idx);
    localStorage.setItem('widget_location', '' + idx);
  };

  return (
    <Grid
      item
      direction='column'
      xs={12}
      container
      component={Paper}
      justifyContent={'center'}
    >
      <Grid
        item
        container
        xs={12}
        style={{ paddingBottom: '.2rem', position: 'relative' }}
        alignItems='center'
        justifyContent='space-between'
      >
        <IconButton onClick={goBack}>
          <ChevronLeft />
        </IconButton>
        <Grid container item xs justifyContent='center' alignItems='center'>
          <Brightness5 />
          <Grid item sx={{ pl: '.5rem' }}>
            <Typography
              component='h4'
              variant='h6'
              style={{ textAlign: 'center' }}
            >
              Weather
            </Typography>
          </Grid>
        </Grid>
        <IconButton onClick={goForward}>
          <ChevronRight />
        </IconButton>
      </Grid>
      {locations && locations[locationIdx] ? (
        <ForecastContainer hide={false} location={locations[locationIdx]} />
      ) : (
        <Grid
          item
          xs={12}
          style={{
            paddingBottom: '1rem',
            marginLeft: '1rem',
            marginTop: '.2rem',
          }}
        >
          <Typography align='left' variant='body2'>
            No locations with weather available. This data refreshes every 15
            minutes.
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default WeatherWidget;
